import React, { useState } from 'react';
import * as FaIcons from 'react-icons/fa';
// import * as AiIcons from 'react-icons/ai';
import { Link } from 'react-router-dom';
// import { SidebarData } from './SidebarData';
import './Navbar.css';
import { IconContext } from 'react-icons';
import Nav from './Nav';

function Navbar() {
  const [sidebar, setSidebar] = useState(false);

  // const showSidebar = () => setSidebar(!sidebar);
  const toggleSidebar = () => setSidebar((prev) => !prev);

  return (
    <>
      <div className=''>
        <IconContext.Provider value={{ color: '#fff', size: "2em" }}>
          <div className='navbar ms-2 me-2 px-2'>
            <Link id={`sidebar-section-path`} to='#' className='menu-bars'>
              <FaIcons.FaBars onClick={toggleSidebar} />
            </Link>
          </div>
        </IconContext.Provider>
      </div>
      <Nav sidebar={sidebar} toggleSidebar={toggleSidebar} />

    </>
  );
}

export default Navbar;